import { render, staticRenderFns } from "./CardTarjaTwitterBBB.vue?vue&type=template&id=251e7ad6&scoped=true"
import script from "./CardTarjaTwitterBBB.vue?vue&type=script&lang=js"
export * from "./CardTarjaTwitterBBB.vue?vue&type=script&lang=js"
import style0 from "./CardTarjaTwitterBBB.vue?vue&type=style&index=0&id=251e7ad6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "251e7ad6",
  null
  
)

export default component.exports